module.exports = __webpack_public_path__ + "logo-rounded.png?c2cca3885f244e7328d2a6a13d4591ab";


//////////////////
// WEBPACK FOOTER
// ./client/assets/logo-rounded.png
// module id = 1504
// module chunks = 0